export default __webpack_public_path__ + "images/video-calling-step-2_2x.5220c452e4637dd9d5a01d116cafce40.png";